import {Component, Inject, OnInit} from '@angular/core';
import {NotificationsService} from "../../../services/notifications.service";
import {ActivatedRoute} from "@angular/router";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {VendorTaxClearanceService} from "../vendor-tax-clearance.service";
import {ViewDialogComponent} from "../view-dialog/view-dialog.component";
import {IContextMenuOption} from "../../context-menu/context-menu.types";

@Component({
    selector: 'app-log-dialog',
    templateUrl: './log-dialog.component.html',
    styleUrls: ['./log-dialog.component.styl']
})
export class LogDialogComponent implements OnInit {
    dataSource;
    contextMenuOptionHeader = [];
    contextMenuOptions: IContextMenuOption[] = [];

    constructor(public notificationsService: NotificationsService,
                private _dialog: MatDialog,
                public activatedRoute: ActivatedRoute,
                public vendorTaxClearanceService: VendorTaxClearanceService,
                @Inject(MAT_DIALOG_DATA) public dialogData?: any,
    ) {}

    ngOnInit() {
        this.notificationsService.startLoading();
        this.contextMenuOptionHeader = [];
        this.contextMenuOptions = [
            {
                title: 'COMMON.VIEW',
                action: (options: any) => {
                    this.openViewDialog(options);
                },
                pipeTranslate: true,
                disabled: (options: any) => {
                    return this.notificationsService.isLoading
                },
            },
        ];
        this.vendorTaxClearanceService.logs(this.dialogData.id).subscribe((data) => {
            this.dataSource = data;
            this.notificationsService.dismissLoading();

        });
    }

    openViewDialog(data) {
        if (data && !data.tin) {
            data.tin = '';
        }
        this._dialog.open(ViewDialogComponent, {
            data: data,
            disableClose: true,
        });
    }

}
